import type { HttpError } from "@/shared/api/client";

// Two error envelopes are in play. Telematics, agrodata and integrations answer
// with `code` (integrations slash-prefixed: "/integrations/vidimte/forbidden");
// cf-rest services (iot, agroevidence, catalogues) answer with `error`, which
// holds the same kind of value, always slash-prefixed: "/iot/device/already-placed".
// That field also carries Spring's reason phrases ("Internal Server Error"),
// which are not codes at all — the leading slash is what tells them apart.
const getBackendCode = (error: HttpError): string | undefined => {
  const data = error.response?.data as
    { code?: string; error?: string } | undefined;
  const code =
    data?.code ?? (data?.error?.startsWith("/") ? data.error : undefined);
  return code?.replace(/^\//, "");
};

export { getBackendCode };
